module.exports = __webpack_public_path__ + "media/images/footer_bg-2ec28502e120d610c0aa9e0370636484.png";